function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_375",
  "data-name": "Group 375",
  transform: "translate(-181.5 -231.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_353",
  "data-name": "Group 353",
  transform: "translate(188.494 235.989)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_324",
  "data-name": "Path 324",
  d: "M.093.018,2.73,0,2.637,13.738,0,13.756Z",
  transform: "translate(7.89 2.688) rotate(33.311)",
  fill: "none",
  stroke: "#566FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_325",
  "data-name": "Path 325",
  d: "M.56.01,2.122,0a.527.527,0,0,1,.534.531L2.637,3.324,0,3.342.019.549A.545.545,0,0,1,.56.01Z",
  transform: "translate(9.793 -0.04) rotate(33.311)",
  fill: "none",
  stroke: "#566FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_298",
  "data-name": "Path 298",
  d: "M617.906,233.112l-.335,2.879,2.549-1.446",
  transform: "translate(-617.571 -218.929)",
  fill: "none",
  stroke: "#566FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_362",
  "data-name": "Path 362",
  d: "M875.394,222.15v-5.4h25v25h-25v-15.3",
  transform: "translate(-693.394 15.253)",
  fill: "none",
  stroke: "#566FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}));

var SvgJoratoCasesDraftLightBlue = function SvgJoratoCasesDraftLightBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJoratoCasesDraftLightBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jorato-cases-draft-light-blue.a802d738.svg";
export { ForwardRef as ReactComponent };